export const POPULATE_ADMINS = "POPULATE_ADMINS";
export const ADD_ADMIN = "ADD_ADMIN";
export const REMOVE_ADMIN = "REMOVE_ADMIN";
export const EDIT_ADMIN = "EDIT_ADMIN";
export const POPULATE_ROLES = "POPULATE_ROLES";
export const POPULATE_DEFAULT_ROLES = "POPULATE_DEFAULT_ROLES";
export const POPULATE_ADMIN_ANALYSIS = "POPULATE_ADMIN_ANALYSIS";
